module.exports = __webpack_public_path__ + "img/cat.43c9bc5e.png";